<template>
  <InternalError />
</template>

<script>
import InternalError from '../components/templates/InternalError'

export default {
  components: {
    InternalError
  }
}
</script>
